module.exports = __webpack_public_path__ + "static/media/sap.073a9648.svg";